import styled from 'styled-components';

const HeadingDiv = styled.div`  
  margin-left: ${props => (props.image ? '10px' : '')};
`;

HeadingDiv.displayName = 'HeadingDiv';

export default HeadingDiv;
